import { ButtonLink, Checkbox, checkboxStates } from 'bench-internal-theme';
import React from 'react';

import { SelectedDataEntriesConsumer } from './SelectedDataEntriesContext';

type DataEntryTableSelectAllButtonProps = {
  controlledDataEntryIds: string[];
};

const DataEntryTableSelectAllButton = ({
  controlledDataEntryIds,
}: DataEntryTableSelectAllButtonProps) => (
  <SelectedDataEntriesConsumer>
    {({ addSelectedDataEntryIds, isDataEntryIdSelected, removeSelectedDataEntryIds }) => {
      const areAllDataEntriesSelected = controlledDataEntryIds.every(isDataEntryIdSelected);
      const areSomeDataEntriesSelected = controlledDataEntryIds.some(isDataEntryIdSelected);
      return (
        <ButtonLink
          onClick={() => {
            if (areAllDataEntriesSelected || areSomeDataEntriesSelected) {
              removeSelectedDataEntryIds(...controlledDataEntryIds);
            } else {
              addSelectedDataEntryIds(...controlledDataEntryIds);
            }
          }}
        >
          <Checkbox
            checkboxState={
              (areAllDataEntriesSelected && checkboxStates.CHECKED) ||
              (areSomeDataEntriesSelected && checkboxStates.INDETERMINATE) ||
              checkboxStates.UNCHECKED
            }
            title="Select All"
          />
        </ButtonLink>
      );
    }}
  </SelectedDataEntriesConsumer>
);

export default DataEntryTableSelectAllButton;
